import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import classes from './DetailsCard.module.scss';
import MainButton from '../../../buttons/MainButton';
import DetailView from './DetailView';
import EditView from './EditView';
import { updateCardStyle } from '../../../../../actions/jobAlerts';
import colors from '../../../../../scss/colors';

const DetailsCard = (props) => {
  const { allAlerts, cardStyleFade } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const sliceVal = useSelector((state) => state.jobAlerts.slice);
  const pendingStatus = useSelector((state) => state.jobAlerts.unsubscribePending);
  const alerts = allAlerts.slice(0, sliceVal);
  const [editView, setEditView] = useState({});
  const [isFade, setFade] = useState(false);

  const renderIndustries = (industries) => {
    return industries.map((industry) => <span key={industry.Id}>{industry.Industry.Name}</span>);
  };

  const renderTypes = (types) => {
    return types.map((type) => `${type.JobType} `);
  };

  const getKeywordOrType = (item) => {
    if (item.Keyword && item.Keyword !== '') {
      return item.Keyword;
    }
    if (item.JobAlertContractTypes.length) {
      return renderTypes(item.JobAlertContractTypes);
    }
    return t('dashboard.settings.contract');
  };

  const renderRemoteWorkStatus = (remoteWork) => {
    const remoteWorkMap = {
      0: 'dashboard.settings.onsite',
      1: 'dashboard.settings.remote',
      2: 'dashboard.settings.onsiteandremote'
    };

    return remoteWorkMap[remoteWork] ? t(remoteWorkMap[remoteWork]) : null;
  };

  const handleEditView = (itemId) => {
    setFade(cardStyleFade);
    dispatch(updateCardStyle(!cardStyleFade));
    setEditView((prev) => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const closeHandler = (itemId) => {
    setFade(cardStyleFade);
    dispatch(updateCardStyle(!cardStyleFade));
    setEditView((prev) => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const handleEditViewChange = (itemId, newValue) => {
    setEditView((prev) => ({
      ...prev,
      [itemId]: newValue
    }));
  };

  useEffect(() => {}, [pendingStatus, alerts]);

  if (pendingStatus) {
    return <CircularProgress sx={{ color: colors.PRIMARY_BLUE }} size={60} />;
  }

  return alerts && alerts.length > 0 && !pendingStatus ? (
    alerts.map((item) => {
      const isEditViewVisible = editView[item.Id];
      return (
        <div
          className={`${classes.listContainer} ${isFade && classes.forceSelectedItem} ${
            isEditViewVisible && Object.keys(editView).length && cardStyleFade ? classes.selectedItem : ''
          } ${!isEditViewVisible && Object.keys(editView).length && cardStyleFade ? classes.unselectedItem : ''}`}
          key={item.Id}
        >
          <div className={classes.detailView}>
            <div className={classes.detailHeader}>
              <div className={classes.headerText} role="presentation" onClick={() => handleEditView(item.Id)}>
                {getKeywordOrType(item)}
                {item.Location ? ` (${item.Location})` : ` (${t('dashboard.settings.everywhere')})`}
              </div>
              {isEditViewVisible ? (
                <CloseIcon onClick={() => closeHandler(item.Id)} />
              ) : (
                <EditIcon className={classes.editIcon} onClick={() => handleEditView(item.Id)} />
              )}
            </div>
            {isEditViewVisible ? (
              <EditView
                item={item}
                renderIndustries={renderIndustries}
                renderTypes={renderTypes}
                renderRemoteWorkStatus={renderRemoteWorkStatus}
                classes={classes}
                isEditViewVisible={isEditViewVisible}
                onEditViewChange={(newValue) => handleEditViewChange(item.Id, newValue)}
                cardStyleFade={cardStyleFade}
              />
            ) : (
              <DetailView
                item={item}
                renderIndustries={renderIndustries}
                renderTypes={renderTypes}
                renderRemoteWorkStatus={renderRemoteWorkStatus}
                classes={classes}
              />
            )}
          </div>
        </div>
      );
    })
  ) : (
    <div className={classes.noAlertContainer}>
      <h4>{t('dashboard.settings.nojobalert')}</h4>
      <div className={classes.labeltext}>{t('dashboard.settings.nojobalertlabel')}</div>
      <MainButton outlined rounded forceWidth="100%" action={() => navigate('/dashboard/jobs')}>
        <span>{t('dashboard.settings.searchforjobs')}</span>
      </MainButton>
    </div>
  );
};

export default DetailsCard;
